import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editLotPopOverTitle: {
    description: 'Edit lot pop-over title',
    defaultMessage: 'Edit Lot',
    id: 'qSjAu1',
  },
  editLotPopoverCancel: {
    description: 'Edit lot pop-over cancel button',
    defaultMessage: 'Cancel',
    id: 'ud0uTj',
  },
  editLotPopoverEdit: {
    description: 'Edit lot pop-over edit button',
    defaultMessage: 'Edit',
    id: '6g3NmF',
  },
  editLotErrorTitle: {
    description: 'Edit lot error notification title',
    defaultMessage: 'Edit Lot Error',
    id: 'hJsvNS',
  },
  editLotErrorMessage: {
    description: 'Edit lot error notification message',
    defaultMessage: 'Error updating lot information',
    id: 'I/vwSx',
  },
});
